import {ColorSchemeType} from 'platform/components';

import {Nullish} from 'shared/web';

import {EVALUATION_UNKNOWN_COLOR, evaluationColors} from '../constants/evaluation';

export function getEvaluationFlagColor(evaluation: string | Nullish): ColorSchemeType {
  return evaluation ? evaluationColors[Number(evaluation)] : EVALUATION_UNKNOWN_COLOR;
}
